module.exports = __webpack_public_path__ + "media/images/your_ad/your_ad_728-18c4788ed5209f94298d18c1bcf83b51.png";